module.exports = __webpack_public_path__ + "static/media/QuestionMark.6e4fcae3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/QuestionMark.svg
// module id = 145
// module chunks = 0